import React from 'react';
import { createPortal } from 'react-dom';

function normalizeValidations(validations) {
  if (!validations) return [];
  if (Array.isArray(validations)) {
    return validations.map(v => ({
      key: v.field ?? v.key ?? v.name ?? '',
      value: v.message ?? v.value ?? v.error ?? String(v),
    }));
  }
  if (typeof validations === 'object') {
    return Object.entries(validations).map(([key, value]) => ({
      key,
      value: Array.isArray(value) ? value.join(', ') : String(value),
    }));
  }
  return [];
}

export default function ValidationErrorModal({ show, onHide, message, validations }) {
  if (!show) return null;

  const items = normalizeValidations(validations);

  return createPortal(
    <div
      role="presentation"
      onClick={onHide}
      style={{
        position: 'fixed', inset: 0, zIndex: 100060,
        background: 'rgba(15, 23, 42, 0.45)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: 14,
          width: '100%', maxWidth: 480, maxHeight: '70vh',
          display: 'flex', flexDirection: 'column',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div style={{ padding: '20px 24px 14px', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-x-circle" style={{ fontSize: 20, color: '#ef4444' }}></i>
              </div>
              <h5 style={{ fontWeight: 700, fontSize: 15, margin: 0, color: '#111827' }}>Xəta baş verdi</h5>
            </div>
            <button
              onClick={onHide}
              style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', flexShrink: 0 }}
            >
              Bağla
            </button>
          </div>
          {message && (
            <p style={{ fontSize: 13, color: '#4b5563', margin: 0 }}>{message}</p>
          )}
        </div>

        {/* Validations */}
        {items.length > 0 && (
          <div style={{ overflowY: 'auto', padding: '0 24px 20px', flexShrink: 1 }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
              {items.map((item, i) => (
                <li key={i} style={{ background: '#fff1f2', border: '1px solid #fecaca', borderRadius: 8, padding: '7px 12px', fontSize: 12 }}>
                  {item.key && <span style={{ fontWeight: 700, color: '#b91c1c' }} dangerouslySetInnerHTML={{ __html: item.key + ': ' }} />}
                  <span style={{ color: '#374151' }} dangerouslySetInnerHTML={{ __html: item.value }} />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
